import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding
  const resourceList = store.getters && store.getters.resourceList
  if (value) {
    let hasPermission = false
    if (Object.prototype.toString.call(value) === '[object String]') {
      hasPermission = resourceList.some(item => {
        return value === item.resourceCode
      })
    } else {
      hasPermission = resourceList.some(item => {
        return value.includes(item.resourceCode)
      })
    }

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  } else {
    throw new Error(`need resourceCode! Like v-permission="frontSiteProjectAgreementPageList"`)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
